import { useIntl, getCurrentLocale } from "@leagueplatform/locales";
import GOOGLE_EN from "assets/google-store/google-store-en.png";
import GOOGLE_ES from "assets/google-store/google-store-es.png";
import GOOGLE_ZH from "assets/google-store/google-store-zh.png";
import { EXTERNAL_URLS } from "common/urls";
import { StoreLink } from "./store-link.component";

const IMAGES: Record<string, string> = {
  es: GOOGLE_ES,
  zh: GOOGLE_ZH,
  en: GOOGLE_EN,
};

export const GoogleStoreLink = () => {
  const { formatMessage } = useIntl();
  const locale = getCurrentLocale();

  return (
    <StoreLink
      href={EXTERNAL_URLS.GOOGLE_PLAY_STORE_APP}
      src={IMAGES[locale] ?? GOOGLE_EN}
      alt={formatMessage({ id: "STR_GET_GOOGLE_PLAY" })}
      css={{  width: "auto" }}
    />
  );
};
